import briefSaveElementAction from 'contest/actions/brief-save-element';

export default function briefUpdateElementAction(context, payload, done) {
    context.dispatch('BRIEF_UPDATE_ELEMENT', payload);

    if (payload.saveNow) {
        context.executeAction(briefSaveElementAction, {
            section: payload.section,
            element: payload.element,
        });
    }
}



// WEBPACK FOOTER //
// ./src/web/js/contest/actions/brief-update-element.jsx